module.exports = __webpack_public_path__ + "img/status-wallet.f67bd867.png";